var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('HeadingContainer',{attrs:{"addPaddingBottom":false,"heading":"Account Settings"}},[_c('div',{staticClass:"col-xs-12"},[_c('NameCard',{staticClass:"mt3",attrs:{"height":"90","user":_vm.user}}),_c('SettingsList',{staticClass:"mt3"})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }